<template lang="html">
    <section class="section vraag w100 clearfix">
        <div class="w100">
            <label class="question" :class="[required ? 'required' : '']" :for="'input-'+name"><h4>{{ label }}</h4></label>
        </div>
        <div class="w50 input" :class="[error ? 'error-text' : '']">
            <input
                type="text"
                class="gt-form-text"
                :class="[error ? 'error' : '']"
                autocomplete="off"
                :id="'input-'+name"
                :value="value"
                @input="$emit('input', $event.target.value)"
            >
            <div class="error-icon d-none">!</div>
            <div class="tooltip bottom">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">{{ error }}</div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        name: String,
        label: String,
        value: String,
        error: String,
        required: Boolean,
    },
}
</script>
